import { createFeatureSelector, createSelector } from "@ngrx/store";
import { UserState } from "./user.reducer";

const getUserFeatureSelector = createFeatureSelector<UserState>("user");

export const getUserInformation = createSelector(getUserFeatureSelector, (state) => state.userInformation);
export const getCurrentSiteOption = createSelector(getUserFeatureSelector, (state) => state.currentSiteOption);
export const getCurrentSiteId = createSelector(
	getUserFeatureSelector,
	(state) => state.currentSiteOption?.siteId ?? state.userInformation.activeSiteId ?? "",
);
export const loggedIn = createSelector(getUserFeatureSelector, (state) => state.loggedIn);
